// components/PimsConfigModal.tsx

import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { PimsField, PimsConfig } from '../../types/pims';

type Props = {
  show: boolean;
  onClose: () => void;
  pimsId: string;
  pimsName: string;
  fields: PimsField[];
  initialValues?: PimsConfig;
  onSave: (data: PimsConfig) => Promise<void>;
  isNew?: boolean;
};

export const PimsConfigModal: React.FC<Props> = ({
  show,
  onClose,
  pimsName,
  fields,
  initialValues = {},
  onSave,
  isNew = false,
}) => {
  const [values, setValues] = useState<PimsConfig>({});
  const [showFields, setShowFields] = useState<{ [key: string]: boolean }>({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValues(initialValues);
    setShowFields({});
  }, [initialValues, fields]);

  const handleChange = (key: string, value: string) => {
    setValues(prev => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    setSaving(true);
    await onSave(values);
    setSaving(false);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{pimsName} Configuration</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {fields.map(field => (
            <Form.Group key={field.key} className="mb-3">
              <Form.Label>{field.label}</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showFields[field.key] ? 'text' : 'password'}
                  value={values[field.key] || ''}
                  onChange={e => handleChange(field.key, e.target.value)}
                  placeholder={field.label}
                  required={field.required}
                />
                <Button
                  variant="outline-secondary"
                  onClick={() =>
                    setShowFields(prev => ({ ...prev, [field.key]: !prev[field.key] }))
                  }
                >
                  {showFields[field.key] ? 'Hide' : 'Show'}
                </Button>
              </InputGroup>
            </Form.Group>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={saving}>
          {isNew ? 'Save' : 'Update'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};